import {setStatus, setUser, setToken, setStatusShow} from './baseSlice';
// import  failStatus  from '../../utils/global/fialStatus/failStatus';
// import * as R from 'ramda';
import axios from "axios";

// import dClient from '../../api/reduxLoaderApi';
import {setCart} from "../cart/cartSlice";
import dClient from '../../Components/api/reduxLoaderApi';
import {strings} from "../../strings";
import {VERIFIED} from "../../constants/actions";
// import { WAITOTP } from '../../../constants/actions';
// import RESETAPP from '../../../utils/global/fns/resetApp';

// export const quickLogin = () => async (dispatch, getState) => {
//   const res = await dClient('get', '/quickLogin', {}, {}, false);
//   if (failStatus(res)) return '';
//   const tok = `Bearer ${res.data.token}`;
//   sessionStorage.setItem('token', JSON.stringify(tok));
//   return dispatch(setToken({ token: tok }));
// };
//
// export const quickLoginUser = () => async (dispatch, getState) => {
//   const res = await dClient('get', '/client/defaultLogin', {}, {}, false);
//   if (failStatus(res)) return '';
//   const tok = `Bearer ${res.data.token}`;
//   sessionStorage.setItem('token', JSON.stringify(tok));
//   return dispatch(setToken({ token: tok }));
// };

export const initCall = () => async (dispatch, getState) => {
    const token = JSON.parse(localStorage.getItem('token'));
    // const user = localStorage.getItem('dXNlcg==')
    // dispatch(setStatusShow('hidden'))
    if (token) {
        // dispatch(setToken({token: ''}));
        // dispatch(setStatus( 'waiting'))
        const checkToken = await dClient('get', 'admin/dashboard/licence', {}, {},1, false);

        console.log(checkToken)
        // console.log(checkToken)
        // dispatch(setToken({token: token}));
        // const decode = decodeURIComponent(escape(atob(user)))
        // dispatch(setUser(JSON.parse(decode)))

        if(checkToken?.status_code === 200){
            dispatch(setStatus(VERIFIED))
            dispatch(setToken({token: token}));
            // if(user){
            //     const decode = decodeURIComponent(escape(atob(user)))
            //     dispatch(setUser(JSON.parse(decode)))
            // }
        }else {
            console.log("logout")
            dispatch(logOut())
        }

    }
    dispatch(setStatusShow('show'))
    const user = localStorage.getItem('dXNlcg==')
    if(user){
        const decode = decodeURIComponent(escape(atob(user)))
        dispatch(setUser(JSON.parse(decode)))
    }
    // if (user) {
    //     const decode = decodeURIComponent(escape(atob(user)))
    //     dispatch(setUser(JSON.parse(decode)))
    // }





};

export const checkCart = () => async (dispatch, getState) => {
    const cart = getState().cart.cart
    const cartStorage = JSON.parse(localStorage.getItem('cart'));
    if (cart !== cartStorage) dispatch(setCart(cartStorage))
};

export const logOut = () => async (dispatch, getState) => {
    dispatch(setUser({}))
    dispatch(setToken({token: ''}))
    dispatch(setStatus( 'waiting'))
    localStorage.removeItem('token')
    localStorage.removeItem('dXNlcg==')
}
